import * as React from 'react'
import {useIntl} from 'react-intl'
import styled from '@emotion/styled'
import {GuestType} from 'types/Hotel'
import {reviewsLabels} from 'utils/reviewsMessages'

import {Icon, IconName} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'

interface Props {
  /** The guest type */
  guestTypeKey: keyof GuestType
  /** The value for the percentage in the label */
  value: number
}

const iconMap: Record<keyof GuestType, IconName> = {
  business: 'Briefcase',
  couples: 'Heart',
  families: 'FaceLove',
  groups: 'People',
  solo: 'Person'
}

const GuestTypeBadgeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${cssTheme.layout.spacing.s900};
  height: ${cssTheme.layout.spacing.s900};
  margin-bottom: ${cssTheme.layout.spacing.s200};
  border-radius: 100%;
  background-color: ${cssTheme.colors.background.neutral.tertiary};
`

export const GuestTypeBadge: React.FC<Props> = ({guestTypeKey, value}) => {
  const {formatMessage} = useIntl()

  const iconName = iconMap[guestTypeKey]

  if (!reviewsLabels[guestTypeKey]) return null

  return (
    <GuestTypeBadgeWrapper>
      <IconWrapper>
        <Icon name={iconName} size="lg" />
      </IconWrapper>

      <Text variant="bodyS">{formatMessage(reviewsLabels[guestTypeKey])}</Text>

      <Text variant="labelS" colorPath="content.neutral.secondary">
        {Math.floor(value)}%
      </Text>
    </GuestTypeBadgeWrapper>
  )
}
